export default __webpack_public_path__ + "static/media/glenn_profile.0b542e09.jpg";